// removed by extract-text-webpack-plugin
module.exports = {"form":"form_1oU8z","input":"input_yTVAx","radioGroup":"radioGroup_1tCby","block":"block_12bj7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/component/studentData/style.css
 ** module id = 935
 ** module chunks = 0
 **/